'use client';

import { useEffect, useState } from 'react';
import { getCdnUrl } from '@/utils/url';
import { CustomEventType } from '../types';
interface Props {
  isLoading?: boolean;
}
const PageLoading = ({
  isLoading = false
}: Props) => {
  const [isVisible, setIsVisible] = useState(isLoading);
  useEffect(() => {
    document.addEventListener(CustomEventType.ShowPageLoading, () => {
      setIsVisible(true);
    });
    document.addEventListener(CustomEventType.HidePageLoading, () => {
      setIsVisible(false);
    });
  }, []);
  if (!isVisible) return null;
  return <div className='fixed right-0 top-0 z-[1003] flex h-screen w-screen items-center justify-center' data-sentry-component="PageLoading" data-sentry-source-file="page-loading.tsx">
            <div className='absolute h-full w-full bg-surface-scrim-white' />
            <img className='h-8 w-8 animate-page-loading' src={getCdnUrl('/_toad/images/loading.svg')} alt='Loading...' />
        </div>;
};
export default PageLoading;